import { LngLatLike } from 'react-map-gl';
import { SourceReferenceSystem } from './RuteplanAPI';
import proj4 from "proj4";

export interface AddressItem {
    order: number;
    name: string;
    location: LngLatLike;
}

export function addressItemLocationToXYCoordinates(addressItem: AddressItem): [number, number] {
    const item = addressItem.location as unknown as [number, number];
    return [item[0], item[1]];
}

export function addressItemLocationToYXCoordinates(addressItem: AddressItem): [number, number] {
    const item = addressItem.location as unknown as [number, number];
    return [item[1], item[0]];
}

export function reprojectAddressItem(addressItem: AddressItem, sourceSrs: SourceReferenceSystem, targetSrs: SourceReferenceSystem) {
    const utm =  "+proj=utm +zone=33 +ellps=GRS80 +units=m +no_defs";
    const wgs84 = "EPSG:4326";    

    const fromSrs = sourceSrs === SourceReferenceSystem.EPSG_25833 ? utm : wgs84;
    const toSrs = targetSrs === SourceReferenceSystem.EPSG_25833 ? utm : wgs84;

    const fromPos = proj4(fromSrs, toSrs, addressItemLocationToXYCoordinates(addressItem));
    addressItem.location = fromPos as [number, number];
}

export const getLocations = async (val : string) => {
    const response = await fetch("https://ws.geonorge.no/stedsnavn/v1/navn?sok=" + encodeURIComponent(val) + "*&maxAnt=20&antPerSide=20&eksakteForst=true");

    const responseData = await response.json();

    var addresses = new Array<AddressItem>();

    if (Array.isArray(responseData.navn)) {
        responseData.navn.forEach((item:any) => {
            addresses.push(CreateAddressItemFromWKItem(item));
        });
    } else if (responseData.navn != null) {
        responseData.navn.forEach(() => {
            addresses.push(CreateAddressItemFromWKItem(responseData.stedsnavn));
        });
    }
    
    return addresses;
};

function CreateAddressItemFromWKItem(item: any) : AddressItem {
    const location: [number, number] = [parseFloat(item.representasjonspunkt.øst),parseFloat(item.representasjonspunkt.nord)]
    let name = item.skrivemåte;
    if (item.kommuner) {
       name += ", " + item.kommuner[0].kommunenavn;
    }
    if (item.fylker) {
        name += ", " + item.fylker[0].fylkesnavn;
    } 
    
    name += " (" + item.navneobjekttype + ")";

    return {name : name, location: location, order: 0};
}
